import { useEffect } from 'react';

export const useUnsavedChanges = (isDirty) => {
  useEffect(() => {
    // This function catches the Browser Refresh/Close
    const handleBeforeUnload = (e) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = ''; // This triggers the browser's native popup
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup when the user leaves the page or saves
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);
};